import React, { useState } from "react";
import { User, LogOut, Menu, X } from "lucide-react";
import { Translator } from "../translate";

export function AgentHeader({ currentUser, setTab, onLogout }) {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className="bg-gradient-to-r from-fuchsia-500 via-purple-600 to-indigo-600 text-white">
            <div className="max-w-7xl mx-auto flex items-center justify-between p-3">

                {/* Left: User info */}
                <div className="flex items-center gap-2">
                    {/* Toggle button for menu */}
                    <button
                        onClick={() => setMenuOpen(!menuOpen)}
                        className="lg:hidden inline-flex items-center"
                    >
                        {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                    </button>
                    <User className="w-5 h-5" />
                    <span className="font-semibold">{currentUser.name}</span>
                </div>

                {/* Middle: Menu toggle */}
                <div className="flex items-center gap-4">
                    

                    {/* Desktop menu */}
                    <div className="hidden lg:flex items-center gap-4">
                        <button onClick={() => setTab("oversikt")} className="hover:underline">Oversikt</button>
                        <button onClick={() => setTab("avtaler")} className="hover:underline">Avtaler</button>
                        <button onClick={() => setTab("kalender")} className="hover:underline">Kalender</button>
                        <button onClick={() => setTab("utbetalinger")} className="hover:underline">Utbetalinger</button>
                        <button onClick={() => setTab("meldinger")} className="hover:underline">Meldinger</button>
                        <button onClick={() => setTab("profil")} className="hover:underline">Profil</button>
                        <button onClick={() => setTab("innstillinger")} className="hover:underline">Innstillinger</button>
                    </div>
                </div>
                {/* Right: language switch + logout */}
                <div className="flex items-center gap-3">
                    <Translator />
                    <button
                        onClick={onLogout}
                        className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1"
                    >
                        <LogOut className="w-4 h-4" /> Logg ut
                    </button>
                </div>
            </div>

            {/* Mobile dropdown menu */}
            {menuOpen && (
                <div className="lg:hidden flex flex-col gap-2 px-4 pb-3">
                    <button onClick={() => setTab("oversikt")} className="hover:underline">Oversikt</button>
                    <button onClick={() => setTab("avtaler")} className="hover:underline">Avtaler</button>
                    <button onClick={() => setTab("kalender")} className="hover:underline">Kalender</button>
                    <button onClick={() => setTab("utbetalinger")} className="hover:underline">Utbetalinger</button>
                    <button onClick={() => setTab("meldinger")} className="hover:underline">Meldinger</button>
                    <button onClick={() => setTab("profil")} className="hover:underline">Profil</button>
                    <button onClick={() => setTab("innstillinger")} className="hover:underline">Innstillinger</button>
                </div>
            )}
        </div>
    );
}